import { render, staticRenderFns } from "./FeedbackReportDetail.vue?vue&type=template&id=d319a0f8&scoped=true"
import script from "./FeedbackReportDetail.vue?vue&type=script&lang=ts"
export * from "./FeedbackReportDetail.vue?vue&type=script&lang=ts"
import style0 from "./FeedbackReportDetail.vue?vue&type=style&index=0&id=d319a0f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d319a0f8",
  null
  
)

export default component.exports